import React, { Component } from 'react';
import { Container, Col, Row, Modal, Button } from 'react-bootstrap';
import apiRequests from './api-helpers/ApiRequests'
import { useSelector } from 'react-redux'
import update from 'react-addons-update';
import Select from 'react-select';
import Drivers from './Drivers';
import { useTranslation } from 'react-i18next';

class ShowEventNotificationForm extends Component {


	constructor(props) {
		super(props);


		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
		formattedSelectedDay.setHours(12, 0, 0, 0);
		formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"


		this.defaultNotificationValue = {
			EventNotification: {
				EventDate: formattedSelectedDay,
				Target: "0",
				TransportsToAdd: [],
				
			},
			errors: "",
			isValidForm: true
		}


		this.state = {
			...this.defaultNotificationValue,
			Contractors: [],
			Stuffs: [],
			Drivers: [],
			Cars: [],
			Semitrailers: []
		}

		this.hideModal = this.hideModal.bind(this);
		this.loadSelectControls = this.loadSelectControls.bind(this);
		this.loadSelectDriversControlsCallback = this.loadSelectDriversControlsCallback.bind(this);
		this.loadSelectCarsControlsCallback = this.loadSelectCarsControlsCallback.bind(this);
		this.loadSelectSemitrailersControlsCallback = this.loadSelectSemitrailersControlsCallback.bind(this);



		this.loadSelectControls();

	}


	componentDidUpdate(prevProps) {

		if ((prevProps.show !== this.props.show) && !prevProps.show) {

			

		}

	}

	loadSelectControls() {

		let params =
		{
			DataInHttpResponse: true,
			SearchParams: [
				{ Name: "page", Value: "1" },
				{ Name: "size", Value: "10000000" },
				{ Name: "ExtCompanyId", Value: this.props.userData.CompanyWorkflowId + "X" }

			]
		};

		//apiRequests.getDataByUrlWithParam('webconapi/GetContractorsItems', params, this.loadSelectGroupBPSControlsCallback);
		//apiRequests.getDataByUrlWithParam('webconapi/GetStuffsItems', params, this.loadSelectStuffsControlsCallback);
		apiRequests.getDataByUrlWithParam('webconapi/GetDriversDictionaryItems', params, this.loadSelectDriversControlsCallback);
		apiRequests.getDataByUrlWithParam('webconapi/GetCarsDictionaryItems', params, this.loadSelectCarsControlsCallback);
		apiRequests.getDataByUrlWithParam('webconapi/GetSemitrailersItems', params, this.loadSelectSemitrailersControlsCallback);

	}

	loadSelectDriversControlsCallback(Drivers) {

		this.setState((prevState) => ({
			Drivers
		}));
	}

	loadSelectCarsControlsCallback(Cars) {

		this.setState((prevState) => ({
			Cars
		}));


	}

	loadSelectSemitrailersControlsCallback(Semitrailers) {

		this.setState((prevState) => ({
			Semitrailers
		}));


	}

	hideModal() {

		this.props.onChangeShowEventNotificationFormVisibilityHandler(false);

	}


	render() {

		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
		formattedSelectedDay.setHours(12,0,0,0);
		formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"

		let currentNotification = this.props.notificationsList.find(x => x.Signature == this.props.signature);
		let transports = [];

		if (currentNotification) 
			transports = currentNotification.Transports;


		let a = this.state.Drivers[0];

		return (

			<>
				<Modal  dialogClassName="modal-large-size" show={this.props.show} onHide={this.hideModal}>
					<Modal.Header closeButton>
						<Modal.Title>
							{currentNotification ? currentNotification.Signature : ""}
							<br />
							<h6 className="text-muted">{this.props.t('notifyView.modalSubtitle')}: {currentNotification ? currentNotification.Transports[0].AccountWorkflowName :  ""} </h6>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className="">
						<form id="new-ev-not-form" onSubmit={this.onFormSubmit}>
							<Container fluid>
								<Row>
									<Col sm={6} className="form-font">
										<div className="mb-3 d-none">
											<label htmlFor="dt1" className="form-label m-0 p-0">Data</label>
											<input type="datetime-local" className="form-control" id="dt1" name="EventDate" onChange={this.onInputChange} defaultValue={currentNotification ? currentNotification.EventDate : ""} readOnly="readonly" />
										</div>
										<div className="mb-3">
											<label htmlFor="transportSignature" className="form-label m-0 p-0">{this.props.t('notifyView.transportOrder')}</label>
											<input type="text" className="form-control" id="transportSignature" name="TransportSignature" value={currentNotification ? currentNotification.Transports[0].TransportSignature : ""} onChange={this.onInputChange} readOnly="readonly" />
											<span className="text-danger">{this.state.errors.TransportSignature ? this.state.errors.TransportSignature[0] : ""}</span>
										</div>

										<div className="mb-3">
											<label htmlFor="gate" className="form-label m-0 p-0">{this.props.t('notifyView.gate')}</label>


											<input type="text" className="form-control" id="gate" name="gate" value={currentNotification ? currentNotification.Transports[0].GateName : ""} onChange={this.onInputChange} readOnly="readnly" />

										</div>

										<div className="mb-3">
											<label htmlFor="target" className="form-label m-0 p-0">{this.props.t('notifyView.target')}</label>
											<select className="form-select" name="Target" id="target" value={currentNotification ? currentNotification.Transports[0].Target : 0} aria-label="Wybierz..." onChange={this.onInputChange} disabled>
												<option value="0">{this.props.t('notifyView.targetPickup')}</option>
												<option value="1">{this.props.t('notifyView.targetWithGoods')}</option>
											</select>
										</div>
										
											
											<div className="mb-3">
											<label htmlFor="groupBPS" className="form-label m-0 p-0">{this.props.t('notifyView.contractor')}</label>

											
											<input type="text" className="form-control" id="groupBPS" name="groupBPS" value={currentNotification ? currentNotification.Transports[0].ContractorName : ""} onChange={this.onInputChange} readOnly="readonly" />


											<span className="text-danger">{this.state.errors.GroupBPS ? this.state.errors.GroupBPS[0] : ""}</span>
										</div>
											<div className="mb-3">
											<label htmlFor="stuff" className="form-label m-0 p-0">{this.props.t('notifyView.goods')}</label>

											<input type="text" className="form-control" id="stuff" name="stuff" value={currentNotification && currentNotification.Transports[0].Stuff ? currentNotification.Transports[0].Stuff.Name : ""} onChange={this.onInputChange} readOnly="readonly" />



											</div>
											
									</Col>
									</Row>
								<Row>
									<Col className="form-font">
										<Container className=" m-0 p-0" fluid>
											<Row className=" m-0 p-0 align-items-end">

												<Col sm={2} className=" m-0 p-0  pe-0">
													<p className="m-0 p-0 pb-1 border-bottom fs-6 text-secondary">{this.props.t('notifyView.transportListTitle')}</p>
													<label className="form-label p-0 m-0 mt-1">{this.props.t('notifyView.transportListTitle')}</label>
												</Col>
												<Col sm={2} className=" m-0 p-0  pe-0 border-top">
													<label className="form-label p-0 m-0 mt-1">{this.props.t('notifyView.entryStart')}</label>
												</Col>
												<Col className=" m-0 p-0  pe-1 border-top ">
													<label className="form-label p-0 m-0 mt-1">{this.props.t('notifyView.entryStop')}</label>
												</Col>
												<Col sm={2} className=" m-0  p-0  pe-1 border-top">
													<label className="form-label p-0 m-0 mt-1">{this.props.t('notifyView.car')}</label>
												</Col>
												<Col sm={1} className=" m-0 p-0  border-top">
													<label className="form-label p-0 m-0 mt-1">{this.props.t('notifyView.trailer')}</label>
												</Col>

												<Col sm="auto" className=" m-0 p-0">
													<button type="button" className="border-0 border bg-body pt-1 ps-3   m-0 invisible "  ><i className="bi bi-x-square text-danger lh-1 fs-3"></i></button>
												</Col>
											</Row>
										{
										 
											
												transports.map((item, index) => {
													
													let driver =  transports[0].DriverName + ' ' + transports[0].DriverSurname;
													let car = transports[0].CarNum;
													let semitrailer = transports[0].SemitrailerNum;
													
													console.log( "transports ====== ", transports[0] );
												return <Row className=" m-0 p-0 mb-1" key={index}>

													<Col sm={2} className=" m-0 p-0 pe-1 ">
														<input type="datetime-local" className="form-control m-0" id={"et" + index} name="EntryStartTime" onChange={(event) => this.onListItemInputChange({ value: event.target.value }, index, "EntryStartTime")} defaultValue={item.EntryStartTime} readOnly="readonly" />
													</Col>

													<Col sm={2} className=" m-0 p-0 pe-1 ">
														<input type="datetime-local" className="form-control m-0" id={"et" + index} name="EntryStopTime" onChange={(event) => this.onListItemInputChange({ value: event.target.value }, index, "EntryStopTime")} defaultValue={item.EntryStopTime} readOnly="readonly" />
													</Col>

													<Col className=" m-0 p-0 pe-1">
														<input type="text" className="form-control m-0" id="" name="" value={driver ? driver : ""} readOnly="readonly" />
														<span className="text-danger">{this.state.errors["TransportsToAdd[" + index + "].Driver"] ? this.state.errors["TransportsToAdd[" + index + "].Driver"][0] : ""}</span>
													</Col>

													<Col sm={2} className=" m-0 p-0 pe-1">
														<input type="text" className="form-control  m-0" value={car ? car : ""} onChange={this.onInputChange} readOnly="readonly" />
														<span className="text-danger">{this.state.errors["TransportsToAdd[" + index + "].Car"] ? this.state.errors["TransportsToAdd[" + index + "].Car"][0] : ""}</span>
													</Col>

													<Col sm={1} className=" m-0 p-0">
														<input type="text" className="form-control  m-0" value={semitrailer ? semitrailer : ""} onChange={this.onInputChange} readOnly="readonly" />
														<span className="text-danger">{this.state.errors["TransportsToAdd[" + index + "].Semitrailer"] ? this.state.errors["TransportsToAdd[" + index + "].Semitrailer"][0] : ""}</span>
														</Col>

													<Col sm="auto" className=" m-0 p-0">
														<button type="button" className="border-0 border bg-body pt-1 ps-3  m-0 invisible" onClick={() => this.deleteItemRow(index)}  ><i className="bi bi-x-square text-danger lh-1 fs-3"></i></button>
														</Col>
												</Row>



											})
											}
											</Container>
									</Col>
								</Row>
								<Row>
									<Col className="">
										<button type="button" className="btn btn-primary d-none" onClick={this.addNewItemRow}>{this.props.t('common.add')}</button>
									</Col>

								</Row>
							</Container>
						</form>
					</Modal.Body>
					<Modal.Footer>
						
					   {/* <button form="new-ev-not-form" type="submit" className="btn btn-primary d-none">
							Dodaj
						</button>*/}
						<Button variant="secondary" onClick={this.hideModal} >
							{this.props.t('common.close')}s
						</Button>
					</Modal.Footer>
				</Modal>
			</>
		);
	}
}


function withMyHook(Component) {
	return function WrappedComponent(props) {

		const signalRCurrentConnection = useSelector((state) => state.signalRCurrentConnection.connection);
		const { t } = useTranslation();

		return <Component {...props} signalRCurrentConnection={signalRCurrentConnection} t={t} />;
	}
}

export default withMyHook(ShowEventNotificationForm)